import { Box } from "@mui/material";
import { SearchFieldError } from "./types";

const HelperText = ({ errors }: { errors: SearchFieldError[] }) => {
  return (
    <Box
      sx={{
        color: (theme) => theme.palette.error.dark,
        width: "100%",
        textAlign: "right",
        marginBottom: 2,
        fontSize: 12,
      }}
    >
      <div style={{ whiteSpace: "pre-line" }}>
        {errors.map(({ title, error }) => (
          <div key={title + error}>
            <strong>{title}:</strong> {error}
          </div>
        ))}
      </div>
    </Box>
  );
};

export default HelperText;
